import React, { Component } from "react";
import axios from "axios";
import constant from "../../constant";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { LinkedIn } from "react-linkedin-login-oauth2";
import GoogleLogin from "react-google-login";

import LoginComp from "../../components/LoginComp";
import SignupComp from "../../components/SignupComp";
import LostPasswordComp from "../../components/LostPasswordComp";

import { LoadingComp } from "../../components/LoadingComp";
import "./style.scss";
import PopupComp from "../../components/PopupComp";

const responseLinkedinFailure = response => {
  // console.log(response);
};

const responseGoogleFailure = response => {
  // console.log(response);
};

export default class Credentials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: "login",
      isLostPassword: true,
      isPage: false,
      isValid: false,
      isLoading: false,
      show_password: false,
      show_confirm_password: false,
      errors: {}
    };
  }

  componentDidMount() {
    let _this = this;
    let { match, isPopup } = this.props;

    if (!isPopup) {
      if (
        match.path === "/signup" ||
        match.path === "/login" ||
        match.path === "/verification" ||
        match.path === "/verification/:id" ||
        match.path === "/lost-password" ||
        match.path === "/lost-password/:id" ||
        match.path === "/lost-password-link"
      ) {
        this.setState({
          isPage: true
        });
      }

      if (match.path === "/signup") {
        this.setState({
          page: "signup"
        });
      }

      if (match.path === "/lost-password/:id") {
        this.setState({
          page: "changePassword"
        });

        let data = new FormData();
        data.append("todo", "change_password");
        data.append("en_id", match.params.id);

        axios.post(`${constant.phpHost}action/login.php`, data).then(res => {
          if (res.data.status === 200) {
            _this.setState({
              isLostPassword: false
            });
          } else {
            window.location.href = "/login";
          }
        });
      } else if (match.path === "/lost-password") {
        this.setState({
          page: "lostPassword"
        });
      }

      if (match.path === "/lost-password-link") {
        this.setState({
          page: "lost-password-link"
        });
      }

      if (match.path === "/verification/:id") {
        this.setState({
          page: "verification"
        });

        let data = new FormData();
        data.append("todo", "email_verification");
        data.append("en_id", match.params.id);

        axios.post(`${constant.phpHost}action/login.php`, data).then(res => {
          if (res.data.status === 200) {
            let seconds = 10;
            this.countdown(seconds);
          } else {
            window.location.href = "/login";
          }
        });
      } else if (match.path === "/verification") {
        this.setState({
          page: "verify"
        });
      }
    }
  }

  countdown = seconds => {
    let _this = this;
    seconds = seconds - 1;
    if (seconds < 0) {
      window.location.href = "/dashboard/booking";
    } else {
      document.getElementById("countdown").innerHTML = seconds;
      window.setTimeout(() => _this.countdown(seconds), 1000);
    }
  };

  handlePageChange = page => {
    if (this.state.isPage) {
      this.props.history.push({
        pathname: "/" + page
      });
    }

    this.setState({
      page,
      show_password: false,
      show_confirm_password: false,
      errors: {}
    });
  };

  serializedData = data => {
    const serializedData = [];

    for (const k in data) {
      if (data[k]) {
        serializedData.push(`${k}=${encodeURIComponent(data[k])}`);
      }
    }

    return serializedData.join("&");
  };

  handleAxios = (data, val) => {
    let _this = this;
    let errors = {};

    this.setState({
      isLoading: true
    });

    axios
      .post(`${constant.phpHost}action/login.php?todo=${val}`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(res => {
        if (val === "signup") {
          window.location.href = "/verification";
        }

        if (val === "lostPassword") {
          window.location.href = "/lost-password-link";
        }

        if (res.data.status === 200) {
          let O_Auth = {
            token: res.data.token,
            id: res.data.id,
            name: res.data.name,
            dp: res.data.dp,
            currency: res.data.currency,
            isSocial: val === "social" ? true : false
          };

          localStorage.setItem("O_Auth", JSON.stringify(O_Auth));

          let current_url = window.location.href;
          let rent_desk = current_url.indexOf("rent-desk");
          if (rent_desk > -1) {
            window.location.reload();
          } else {
            if (_this.props.handleListing) {
              _this.props.handleListing(res.data.id);
            } else {
              window.location.href = "/dashboard/booking";
            }
          }
        } else {
          if (val === "login") {
            errors["email_error"] = "The email and password does not match";
          }
        }

        _this.setState({
          errors,
          isLoading: false
        });
      });
  };

  responseGoogle = response => {
    if (response.Ca) {
      let data = {
        oauth_provider: "google",
        oauth_uid: response.profileObj.googleId,
        name: response.profileObj.name,
        email: response.profileObj.email,
        pic_full_url: response.profileObj.imageUrl
      };

      this.handleAxios(this.serializedData(data), "social");
    }
  };

  responseFacebook = response => {
    if (response.id) {
      let data = {
        oauth_provider: "facebook",
        oauth_uid: response.id,
        name: response.name,
        email: response.email
      };

      this.handleAxios(this.serializedData(data), "social");
    }
  };

  responseLinkedinSuccess = response => {
    let _this = this;

    if (response.code) {
      this.setState({
        isLoading: true
      });

      axios
        .get(
          `${constant.phpHost}action/login.php/?todo=linkedin&m=1&c=${response.code}`
        )
        .then(res => {
          if (res && res.data && res.data.access_token) {
            axios
              .get(
                `${constant.phpHost}action/login.php/?todo=linkedin&m=0&c=${res.data.access_token}`
              )
              .then(resp => {
                const datas = resp.data;
                const profile = datas.profile;
                let data = {
                  oauth_provider: "linkedin",
                  oauth_uid: profile.id,
                  name: `${profile.localizedFirstName} ${profile.localizedLastName}`,
                  email: datas.email.elements[0]["handle~"].emailAddress,
                  pic_full_url:
                    datas.picture.profilePicture["displayImage~"][
                      "elements"
                    ][2]["identifiers"][0].identifier
                };

                _this.handleAxios(_this.serializedData(data), "social");
              });
          }
        });
    }
  };

  handleValidate = (e, val) => {
    let errors = {};

    if (val === "login") {
      if (e.target.email.value === "") {
        errors["email"] = "The email cannot be empty";
        e.target.email.focus();
        this.setState({
          errors
        });
        return;
      }

      if (e.target.password.value === "") {
        errors["password"] = "The password cannot be empty";
        e.target.password.focus();
        this.setState({
          errors
        });
        return;
      }

      return true;
    }

    if (val === "signup") {
      let name_regx = /^[a-zA-Z ,.'-]+$/;
      let email_regx = /\b[a-zA-Z0-9\u00C0-\u017F._%+-]+@[a-zA-Z0-9\u00C0-\u017F.-]+\.[a-zA-Z]{2,}\b/;
      let password_regx = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

      if (!e.target.name.value.match(name_regx)) {
        errors["name"] = "Please type only characters";
        e.target.name.focus();
        this.setState({
          errors
        });
        return;
      }

      if (!e.target.email.value.match(email_regx)) {
        errors["email"] = "Please type valuable email";
        e.target.email.focus();
        this.setState({
          errors
        });
        return;
      }

      if (!e.target.password.value.match(password_regx)) {
        if (!e.target.password.value.match(/(?=.*?[A-Z])/))
          errors["password"] = "At least one upper case letter";
        else if (!e.target.password.value.match(/(?=.*?[a-z])/))
          errors["password"] = "At least one lower case letter";
        else if (!e.target.password.value.match(/(?=.*?[0-9])/))
          errors["password"] = "At least one digit";
        else if (!e.target.password.value.match(/(?=.*?[#?!@$%^&*-])/))
          errors["password"] = "At least one special character";
        else errors["password"] = "Minimum eight in length ";

        e.target.password.focus();
        this.setState({
          errors
        });
        return;
      }

      if (e.target.password.value !== e.target.confirm_password.value) {
        errors["confirm_password"] =
          "Please check that you've entered and confirmed your password!";
        e.target.confirm_password.focus();
        this.setState({
          errors
        });
        return;
      }

      return true;
    }

    if (val === "lostPassword") {
      if (e.target.email.value === "") {
        errors["email"] = "The email cannot be empty";
        e.target.email.focus();
        this.setState({
          errors
        });
        return;
      }

      return true;
    }

    if (val === "updatePassword") {
      let password_regx = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

      if (!e.target.password.value.match(password_regx)) {
        if (!e.target.password.value.match(/(?=.*?[A-Z])/))
          errors["password"] = "At least one upper case letter";
        else if (!e.target.password.value.match(/(?=.*?[a-z])/))
          errors["password"] = "At least one lower case letter";
        else if (!e.target.password.value.match(/(?=.*?[0-9])/))
          errors["password"] = "At least one digit";
        else if (!e.target.password.value.match(/(?=.*?[#?!@$%^&*-])/))
          errors["password"] = "At least one special character";
        else errors["password"] = "Minimum eight in length ";

        e.target.password.focus();
        this.setState({
          errors
        });
        return;
      }

      if (e.target.password.value !== e.target.confirm_password.value) {
        errors["confirm_password"] =
          "Please check that you've entered and confirmed your password!";
        e.target.confirm_password.focus();
        this.setState({
          errors
        });
        return;
      }

      return true;
    }
  };

  handleSubmit = (e, val) => {
    e.preventDefault();
    let errors = {};
    let _this = this;

    const data = new FormData(e.target);

    if (this.handleValidate(e, val)) {
      if (val !== "updatePassword") {
        let email = e.target.email;
        let check_email = new FormData();
        check_email.append("todo", "check_email");
        check_email.append("email", email.value);

        axios
          .post(`${constant.phpHost}action/login.php`, check_email, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(res => {
            if (val === "signup") {
              if (res.data.status === 200) {
                errors["email"] = "The email is already exist";
                email.focus();
                _this.setState({
                  errors
                });
                return;
              } else {
                _this.handleAxios(data, val);
              }
            } else if (val === "login" || val === "lostPassword") {
              if (res.data.status === 500) {
                errors["email"] = "The email is not registered";
                email.focus();
                this.setState({
                  errors
                });
                return;
              } else {
                _this.handleAxios(data, val);
              }
            }
          });
      } else {
        data.append("en_id", this.props.match.params.id);
        _this.handleAxios(data, val);
      }
    }
  };

  handleShowPassword = (confirm = "") => {
    let { show_password, show_confirm_password } = this.state;
    this.setState({
      show_password: confirm === "confirm" ? show_password : !show_password,
      show_confirm_password:
        confirm === "confirm" ? !show_confirm_password : show_confirm_password
    });
  };

  render() {
    let { isPage, page, isLoading, isLostPassword, errors } = this.state;

    function chk_errors(field) {
      return errors && errors[field] ? (
        <span
          style={{
            color: "red",
            display: "block",
            margin: "15px 0"
          }}
        >
          {errors[field]}
        </span>
      ) : null;
    }

    return (
      <PopupComp
        isPopup={this.props.isPopup}
        className="login_popup"
        show={isPage}
      >
        {/* {isPage ? (
          <div className="banner_img">
            <img src="/assets/images/top_slider.jpg" alt="" />
          </div>
        ) : null} */}

        {!isLoading ? (
          <div className="content">
            {page === "verification" ||
            page === "verify" ||
            page === "lostPassword" ||
            page === "changePassword" ||
            page === "lost-password-link" ? (
              <div>
                {page === "verify" ? (
                  <div className="heading_text">
                    <h1>Thank you for choosing workspaces in heydesk</h1>
                    <p>Please check and click link in your email</p>
                  </div>
                ) : page === "verification" ? (
                  <div>
                    <div className="heading_text">
                      <h1>Thank you for choosing workspaces in heydesk</h1>
                      <p>Add your spaces free of cost</p>
                    </div>
                    <div id="countdown">10</div>Seconds
                  </div>
                ) : page === "lostPassword" || page === "changePassword" ? (
                  <div className="heading_text">
                    <h1>Get started absolutely free</h1>
                    <p>Free forever. No credit card needed</p>
                  </div>
                ) : page === "lost-password-link" ? (
                  <div className="heading_text">
                    <h1>Thank you for verify your email in heydesk</h1>
                    <p>
                      Please check link in your mail and change your password
                    </p>
                  </div>
                ) : null}
              </div>
            ) : (
              <div>
                <div className="heading_text">
                  <h1>Get started absolutely free</h1>
                  <p>Free forever. No credit card needed</p>
                </div>
                <div className="social_icon">
                  <FacebookLogin
                    appId={constant.facebookId}
                    autoLoad={false}
                    fields="name,email,picture"
                    callback={this.responseFacebook}
                    render={({ onClick, disabled }) => (
                      <div onClick={onClick} disabled={disabled}>
                        <i className="fa fa-facebook" />
                        <label>Facebook</label>
                      </div>
                    )}
                  />
                  <LinkedIn
                    clientId={constant.linkedinId}
                    onFailure={responseLinkedinFailure}
                    onSuccess={this.responseLinkedinSuccess}
                    scope="r_liteprofile,r_emailaddress"
                    redirectUri={constant.linkedinUri}
                    renderElement={({ onClick, disabled }) => (
                      <div onClick={onClick} disabled={disabled}>
                        <i className="fa fa-linkedin" />
                        <label>Linkedin</label>
                      </div>
                    )}
                  />
                  <GoogleLogin
                    clientId={constant.googleId}
                    onFailure={responseGoogleFailure}
                    onSuccess={this.responseGoogle}
                    cookiePolicy={"single_host_origin"}
                    render={({ onClick, disabled }) => (
                      <div onClick={onClick} disabled={disabled}>
                        <i className="fa fa-google" />
                        <label>Google</label>
                      </div>
                    )}
                  />
                </div>

                <div className="or">
                  <span className="or_">
                    <span>OR</span>
                  </span>
                </div>
              </div>
            )}

            {chk_errors("email_error")}

            {page === "login" ? (
              <LoginComp
                page={this.handlePageChange}
                handleShowPassword={this.handleShowPassword}
                show_password={this.state.show_password}
                submit={this.handleSubmit}
                chk_errors={chk_errors}
              />
            ) : page === "signup" ? (
              <SignupComp
                page={this.handlePageChange}
                handleShowPassword={this.handleShowPassword}
                show_password={this.state.show_password}
                show_confirm_password={this.state.show_confirm_password}
                submit={this.handleSubmit}
                chk_errors={chk_errors}
              />
            ) : page === "lostPassword" || page === "changePassword" ? (
              <LostPasswordComp
                page={this.handlePageChange}
                chk_errors={chk_errors}
                isLostPassword={isLostPassword}
                submit={this.handleSubmit}
              />
            ) : null}
          </div>
        ) : (
          <LoadingComp customStyle={{ padding: 0 }} />
        )}
      </PopupComp>
    );
  }
}
